module.exports = __webpack_public_path__ + "img/41.2042ecf5.jpg";